export class Messages {
  public static readonly EMAIL_REQUIRED = 'O campo Email é necessário.';
  public static readonly EMAIL_INVALID = 'E-mail inválido.';
  public static readonly EMAIL_EQUAL = 'Os campos de E-mail devem coincidir.';
  public static readonly EMAIL_NOT_EXISTS = 'E-mail não existente.';
  public static readonly OLD_PASSWORD_REQUIRED = 'O campo Senha Antiga é necessário.';
  public static readonly PASSWORD_REQUIRED = 'O campo Senha é obrigatório.';
  public static readonly PASSWORD_EQUAL = 'Os campos de Senha devem coincidir.';
  public static readonly PASSWORD_MINLENGTH =
    'A senha deve conter no mínimo 8 caracteres.';
  public static readonly PASSWORD_STRENGTH =
    'A senha deve conter no mínimo uma letra e um número.';
  public static readonly GLOSA_AUTOMATICA_REQUIRED =
    'O campo Glosa Automática é necessário.';
  public static readonly CREDENTIALS_INVALID = 'Credenciais Inválidas.';
  public static readonly PROFESSIONAL_NAME_REQUIRED =
    'O campo Nome do Profissional é necessário.';
  public static readonly ORGANIZATION_NAME_REQUIRED =
    'O campo Nome da Organização é necessário.';
  public static readonly GENERIC_ERROR = 'Ocorreu um erro! Verifique sua conexão.';
  public static readonly NOME_EMPRESA_REQUIRED = 'O campo Nome da Empresa é necessário.';
  public static readonly NOME_REQUIRED = 'O campo Nome é necessário.';
  public static readonly CODIGO_REQUIRED = 'O campo Código CNES é necessário.';
  public static readonly CODIGO_REFERENCIADO_REQUIRED =
    'O campo Código do Referenciado é necessário.';
  public static readonly CODIGO_MAXLENGTH = 'O campo Código não pode ter mais 7 digitos.';
  public static readonly IDENTIFICACAO_REQUIRED = 'O campo CNPJ ou CPF é necessário.';
  public static readonly CEP_REQUIRED = 'O campo CEP é obrigatório.';
  public static readonly CEP_INVALID = 'CEP inválido.';
  public static readonly LOGRADOURO_REQUIRED = 'O campo Logradouro é obrigatório.';
  public static readonly NUMERO_REQUIRED = 'O campo Número é obrigatório.';
  public static readonly NUMERO_CONSELHO_REQUIRED =
    'O campo Número do conselho é obrigatório.';
  public static readonly COMPLEMENTO_REQUIRED = 'O campo Complemento é obrigatório.';
  public static readonly BAIRRO_REQUIRED = 'O campo Bairro é obrigatório.';
  public static readonly CIDADE_REQUIRED = 'O campo Cidade é obrigatório.';
  public static readonly ESTADO_REQUIRED = 'O campo Estado é obrigatório.';
  public static readonly NOME_COMPLETO_REQUIRED = 'O campo Nome completo é obrigatório.';
  public static readonly TIPO_ORGANIZACAO_REQUIRED =
    'O campo Tipo da organização é obrigatório.';
  public static readonly NOME_ORGANIZACAO_REQUIRED =
    'O campo Nome da organização é obrigatório.';
  public static readonly NAME_INVALID =
    'Nome inválido. Por favor, informe seu nome completo.';
  public static readonly URL_REQUIRED = 'O campo URL da Organização é necessário.';
  public static readonly FUNCAO_REQUIRED = 'O campo Função é necessário.';
  public static readonly TELEFONE_REQUIRED = 'O campo Telefone é necessário.';
  public static readonly CELLPHONE_REQUIRED = 'O campo Celular é obrigatório.';
  public static readonly CELLPHONE_INVALID = 'Celular inválido.';
  public static readonly TITULAR_REQUIRED = 'O campo Titular é necessário.';
  public static readonly INSCRICAO_REQUIRED = 'O campo CNPJ ou CPF é necessário.';
  public static readonly AGENCIA_REQUIRED = 'O campo Agência é necessário.';
  public static readonly CONTA_REQUIRED = 'O campo Conta é necessário.';
  public static readonly APELIDO = 'O campo Apelido da Conta é necessário.';
  public static readonly BANCO_REQUIRED = 'O campo Banco é necessário.';
  public static readonly VENDEDOR_REQUIRED = 'O campo Vendedor é necessário.';
  public static readonly NOME_MEDICO = 'O campo Nome Completo é necessário.';
  public static readonly CPF_REQUIRED = 'O campo CPF é obrigatório.';
  public static readonly DATA_NASCIMENTO = 'O campo Data de Nascimento é necessário.';
  public static readonly TIPO_TELEFONE = 'O campo Tipo é necessário.';
  public static readonly PLANO_SAUDE = 'O campo Plano de Saúde é necessário.';
  public static readonly DIA_PAGAMENTO =
    'O campo Estimativa de dias para pagamento é necessário.';
  public static readonly DIAS_ENVIO =
    'O campo Lista de dias do mês de envio é necessário.';
  public static readonly UNIDADE_CONTA_REQUIRED =
    'O campo conta de recebimento é necessário.';
  public static readonly UNIDADE_REQUIRED = 'É necessário selecionar uma unidade.';
  public static readonly DIAS_PAGAMENTO_MIN =
    'O campo Estimativa de Dias para Pagamento deve conter um número entre 1 e 180.';
  public static readonly ESPECIALIDADE_REQUIRED =
    'O campo especialidade atendidas é necessário.';
  public static readonly TITULO_CONTRATO = 'O campo Título do Contrato é obrigatório.';
  public static readonly TIPO_CONTRATO = 'O campo Tipo do Contrato é obrigatório.';
  public static readonly ARQUIVO_CONTRATO = 'O campo Arquivo é obrigatório.';
  public static readonly DATA_VIGENCIA_DE_CONTRATO =
    'O campo Data Vigência De é obrigatório.';
  public static readonly DATA_VIGENCIA_ATE_CONTRATO =
    'O campo Data Vigência Até é obrigatório.';
  public static readonly DATA_REAJUSTE_CONTRATO = 'O campo Data Reajuste é obrigatório.';
  public static readonly OBSERVACAO_CONTRATO = 'O campo Observação é obrigatório.';
  public static readonly DATA_REFERENCIA_REQUIRED =
    'O campo Data de Referência é obrigatório.';
  public static readonly PERIODICIDADE_REQUIRED = 'O campo Periodicidade é obrigatório.';
  public static readonly PRAZO_PAGAMENTO_REQUIRED =
    'O campo Prazo para Pagamento é obrigatório.';
  public static readonly CONSELHO_REQUIRED =
    'O campo Conselho Profissional é obrigatório.';
  public static readonly TIPO_REQUIRED = 'O campo Tipo é obrigatório.';
  public static readonly DESCRICAO_REQUIRED = 'O campo Nome Fantasia é obrigatório.';
  public static readonly DATA_ABERTURA = 'O campo Data de Abertura é obrigatório.';
  public static readonly FONTE_RECEBIMENTO =
    'O campo Fonte de Recebimento é obrigatório.';
  public static readonly MODALIDADE_RECEBIMENTO =
    'O campo Modalidade de Recebimento é obrigatório.';
  public static readonly CNPJ_REQUIRED = 'O campo CNPJ é obrigatório.';
  public static readonly CNPJ_INVALID = 'CNPJ inválido.';
  public static readonly RAZAO_SOCIAL_REQUIRED = 'O campo Razão social é obrigatório.';
  public static readonly NOME_FANTASIA_REQUIRED = 'O campo Nome fantasia é obrigatório.';
  public static readonly DATA_ABERTURA_REQUIRED =
    'O campo Data de abertura é obrigatório.';
  public static readonly DATA_ABERTURA_INVALID = 'O campo Data de abertura é inválido.';
  public static readonly CPF_INVALID = 'CPF inválido.';
  public static readonly DATA_NASCIMENTO_REQUIRED =
    'O campo Data de nascimento é obrigatório.';
  public static readonly ESPECIALIDADES_MEDICAS_REQUIRED =
    'O campo Especialidades médicas é obrigatório.';
  public static readonly REQUIRED = 'Obrigatório.';
  public static readonly DOCUMENTO_IDENTIFICACAO =
    'O Documento de Identificação é obrigatório.';
  public static readonly DOCUMENTO_ATIVIDADE = 'O Documento de Atividade é obrigatório.';
  public static readonly DOCUMENTO_RESIDENCIA =
    'O Documento de Residência é obrigatório.';
  public static readonly DOCUMENTO_CNPJ_OU_CONTRATO_SOCIAL =
    'O Documento CNPJ/Contrato Social é obrigatório.';
  public static readonly TIPO_DOCUMENTO = 'o Tipo de documento é inválido.';
  public static readonly TAMANHO_DOCUMENTO =
    'O tamanho do documento não pode exceder 2MB.';
  public static readonly MAIOR_QUE_18 =
    'A Data de Nascimento deve ser maior que 18 anos.';
  public static readonly TERMO_ACORDO = 'O campo Termo de acordo é obrigatório.';
  public static readonly MAX_LENGTH =
    'O campo pode ter no máximo {requiredLength} caracteres.';
  public static readonly DATE_INVALID = 'Data inválida.';
}
